import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {RouterModule} from '@angular/router';
import {DividerComponent} from './components/divider/divider.component';
import {MenuComponent} from './components/menu/menu.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NoDataComponent} from './components/no-data/no-data.component';
import {MatSelectModule} from '@angular/material/select';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import {NomeEmpresaPipe} from './utils/nome-empresa.pipe';
import {RolePipe} from './utils/role.pipe';
import {MatTreeModule} from '@angular/material/tree';
import {MatTabsModule} from '@angular/material/tabs';
import {UpdatePasswordComponent} from './components/update-password/update-password.component';
import {AlertEmpresaComponent} from './components/alert-empresa/alert-empresa.component';
import {LoaderComponent} from './components/loader/loader.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LoaderService} from './services/loader/loader.service';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {Snackbar} from './utils/snackbar.utils';
import {ChartBarComponent} from './components/charts/chart-bar/chart-bar.component';
import {ToltipDirective} from './directives/toltip/toltip.directive';
import {SwitchesComponent} from './components/switches/switches.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {NavigationBarComponent} from './components/navigation-bar/navigation-bar.component';
import {MatBadgeModule} from '@angular/material/badge';
import {NotificationsComponent} from './components/navigation-bar/components/notifications/notifications.component';
import {UserDetailsComponent} from './components/navigation-bar/components/user-details/user-details.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {FormaPagamentoPipe} from './pipes/forma-pagamento/forma-pagamento.pipe';
import {MatSidenavModule} from '@angular/material/sidenav';
import { TableSkeletonComponent } from './components/table-skeleton/table-skeleton.component';
import { MrrComponent } from './components/mrr/mrr.component';
import {MrrSkeletonComponent} from './components/mrr/components/mrr-skeleton/mrr-skeleton.component';
import {MrrUpComponent} from './components/mrr/components/mrr-up/mrr-up.component';
import {MrrDownComponent} from './components/mrr/components/mrr-down/mrr-down.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { CpfPipe } from './pipes/cpf.pipe';
import { TelefonePipe } from './pipes/telefone.pipe';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';

@NgModule({
  declarations: [
    MenuComponent,
    DividerComponent,
    NoDataComponent,
    NomeEmpresaPipe,
    RolePipe,
    UpdatePasswordComponent,
    AlertEmpresaComponent,
    LoaderComponent,
    ConfirmationDialogComponent,
    ChartBarComponent,
    ToltipDirective,
    SwitchesComponent,
    NavigationBarComponent,
    NotificationsComponent,
    UserDetailsComponent,
    FormaPagamentoPipe,
    TableSkeletonComponent,
    MrrComponent,
    MrrSkeletonComponent,
    MrrUpComponent,
    MrrDownComponent,
    BreadcrumbComponent,
    CpfPipe,
    TelefonePipe,
    BarChartComponent
  ],
  exports: [
    MenuComponent,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    DividerComponent,
    ReactiveFormsModule,
    MatTableModule,
    MatTooltipModule,
    NoDataComponent,
    MatSelectModule,
    MatExpansionModule,
    MatCardModule,
    NomeEmpresaPipe,
    RolePipe,
    UpdatePasswordComponent,
    AlertEmpresaComponent,
    MatTreeModule,
    MatTabsModule,
    LoaderComponent,
    MatProgressSpinnerModule,
    ToltipDirective,
    ChartBarComponent,
    MatDatepickerModule,
    SwitchesComponent,
    MatNativeDateModule,
    NavigationBarComponent,
    MatBadgeModule,
    MatPaginatorModule,
    FormaPagamentoPipe,
    MatSidenavModule,
    TableSkeletonComponent,
    MrrComponent,
    MrrSkeletonComponent,
    MrrUpComponent,
    MrrDownComponent,
    BreadcrumbComponent,
    MatAutocompleteModule,
    CpfPipe,
    TelefonePipe,
    BarChartComponent
  ],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    RouterModule,
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatTableModule,
    MatTooltipModule,
    MatSelectModule,
    MatExpansionModule,
    MatCardModule,
    MatTreeModule,
    MatTabsModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatNativeDateModule,
    MatBadgeModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatAutocompleteModule
  ],
  providers: [
    MatSnackBarModule,
    MatButtonModule,
    NomeEmpresaPipe,
    RolePipe,
    LoaderService,
    Snackbar,
    ToltipDirective,
  ]
})
export class SharedModule {
}
